import { Stack } from "@mui/material";
import { Button } from "components/ButtonNew";
import { CustomModal } from "components/CustomModal";
import { TextFieldInput } from "components/Input";
import { useState } from "react";

type HeatmapValueModalProps = {
  applyLabel: string;
  cancelLabel: string;
  description: string;
  onApply: (value: number) => void;
  onClose: () => void;
  open: boolean;
  title: string;
  valueLabel: string;
};

export const HeatmapValueModal = ({
  applyLabel,
  cancelLabel,
  description,
  onApply,
  onClose,
  open,
  title,
  valueLabel,
}: HeatmapValueModalProps) => {
  const [value, setValue] = useState("0");

  const handleApply = () => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return;
    onApply(parsed);
    setValue("0");
  };

  return (
    <CustomModal
      height="auto"
      modalOpen={open}
      padding="2.4rem"
      setModalOpen={(isOpen) => {
        if (!isOpen) onClose();
      }}
      width="28rem"
    >
      <form onSubmit={handleApply}>
        <h3 className="text-lds-foreground-heading font-ds-headline-md">{title}</h3>
        <p className="font-ds-body-regular-sm mt-2 text-lds-foreground-muted">{description}</p>
        <div className="mt-5">
          <TextFieldInput
            height="4rem"
            label={valueLabel}
            onChange={(event) => setValue(event.target.value)}
            type="number"
            value={value}
          />
        </div>
        <Stack className="mt-6 justify-end gap-3">
          <Button onClick={onClose} size="sm" type="button" variant="secondary">
            {cancelLabel}
          </Button>
          <Button onClick={handleApply} size="sm" type="submit" variant="primary">
            {applyLabel}
          </Button>
        </Stack>
      </form>
    </CustomModal>
  );
};
